import $ from 'jquery';
import './app.js';

window.jQuery = window.$ = $;

$(function() {
    let home_show_count = 0;
    let home_show_timer;
    //time in seconds
    let home_show_time_dialog = 240;
    let home_show_time_redirect = 300;
    let no_dialog_redirect = 240;
    if(location.pathname.split('/').slice(-1)[0] = "/") {
        // Set the initial index
        let currentIndex = 0;

        // Function to show the next image
        function showNextImage() {
            // Hide all images
            $('.wrapper .ss_slide').addClass('hidden');

            // Show the current image
            $('.wrapper .ss_slide').eq(currentIndex).removeClass('hidden');

            // Increment the index for the next iteration
            currentIndex = (currentIndex + 1) % $('.wrapper .ss_slide').length;

            // Use fadeIn() for a smooth transition
            $('.wrapper .ss_slide:not(.hidden)').fadeIn(1000);
        }

        showNextImage();
        
        // Set an interval to call the showNextImage function every (30 seconds)
        setInterval(showNextImage, 30000);
        home_show_restart();
    }

    if($(".sidebar")) {
        $(".sidebar li").on("click", function() {
            $(".sidebar li").removeClass("active");
            $(this).addClass("active");
            var image = $(this).data("nav");
            $(`img.body-image`).hide();
            $(`#${image}`).show();
            var aside = $("aside li:contains('50 mg RESULTS')");
            switch (image) {
                case "50mg": 
                    aside.attr("data-modal", '50mg');
                    aside.attr("data-nav", '50mg');
                    break;
                case "4hours": 
                    aside.attr("data-modal", '50mg4hrs');
                    aside.attr("data-nav", '50mg4hrs');
                    break;
                case "2to": 
                    aside.attr("data-modal", '50mg2to');
                    aside.attr("data-nav", '50mg2to');
                    break;
                default:
            }
        });
    }

    $(".expand").on("click", function(){
        $(this).hide();
        $(".isi").addClass("expanded");
        $(".overlay").addClass("active").show();
        $(".close").show();
    });

    $(".close, .overlay").on("click", function() {
        $(this).hide();
        $(".isi").removeClass("expanded");
        $(".overlay").removeClass("active").hide();
        $(".expand").show();
        home_show_restart();
    });

    $("aside.content li[data-modal]").on("click", function() {
        var modalId = $(this).text().toLowerCase().split(" ");
        switch(modalId[1]) {
            case "&":
              modalId[1] = "";
              break;
            case undefined:
              modalId[1] = "";
              break;
            default:
              // Do no thing
              break;   
        }
        $(".overlay").toggle();
        switch(true) {
            case $("div.references").length > 1 && modalId[0] + modalId[1] === "references":
                var sidebarVal = $(".sidebar .active").data("nav");
                $(`#references${sidebarVal}`).show();
                break;
            case modalId[0] + modalId[1] === "50mg":
                var sidebarVal = $(".sidebar .active").data("nav");
                console.log("sidebarVal", sidebarVal)
                switch (sidebarVal) {
                    case "4hours":
                        $(`#50mg4hours`).show();
                        break;
                    case "2to":
                        $(`#50mg2to`).show();
                        break;
                    default:
                        $(`#50mg`).show();
                }
            default:
                if(modalId[0] + modalId[1] !== "50mg") {
                    $(`#${modalId[0] + modalId[1]}`).show();
                }
        }
    });

    if(".modal") {
        $(".modal").each(function() {
            $(this).prepend(`<img src="assets/img/modal/close.svg" alt="close" class="close-modal" />`);
        });

        $(".close-modal").on("click", function() {
            $(this).parent().hide();
            $(".overlay").hide();
        });

        $(".overlay").on("click", function() {
            $(".modal").hide();
            $(".overlay").hide();
        });

        $(".close-in-modal").on("click", function() {
            home_show_restart();
            $("#timeout").hide();
            $(".overlay").hide();
            $(".modal").hide();
        });
    }

    function home_show_create(){
        home_show_timer = setInterval(home_show_interval, 1000);
    }
    
    function home_show_interval(){
        home_show_count += 1;
        var path = location.pathname.split('/').slice(-1)[0];
        console.log("the path is:", path)
        switch(path) {
            case "home.html":
                console.log("Redirect after 4 mins - No modal");
                if (home_show_count > no_dialog_redirect) {
                    window.location.href = "./index.html"
                }
                break;
            case "":
                console.log("Do nothing");
                // do nothing
                break;
            case "/":
                console.log("Do nothing");
                // do nothing
                break;
            case "/index":
                console.log("Do nothing");
                // do nothing
                break;
            case "index.html":
                console.log("Do nothing");
                // do nothing
                break;
            default:
                console.log("Redirect after 5 mins - with modal");
                if ( home_show_count >= home_show_time_dialog && home_show_count < home_show_time_redirect ) {
                    $(".modal").hide();
                    $(".overlay").show();
                    $("#timeout").show();
                }
                if ( home_show_count >= home_show_time_redirect ) {
                    home_show_count = 0;
                    $(".overlay").hide();
                    $("#timeout").hide();
                    window.location.href = "./index.html"
                }
                break;
        }
    }
    
    function home_show_delete(){
        home_show_count = 0;
        clearInterval(home_show_timer);
    }
    
    function home_show_restart(){
        home_show_delete();
        home_show_count = 0;
        home_show_create();
    }
    
});



